import { companyHasSinglePermission, userHasSinglePermission } from 'util/PermissionsUtils';
import { Permission as P } from 'common/models/Permissions';

export const AllowOpportunitiesModule = () =>
  userHasSinglePermission(P.Opportunities) && companyHasSinglePermission(P.Opportunities);
export const AllowOpportunitiesAddEdit = () =>
  userHasSinglePermission(P.OpportunitiesAddEdit) &&
  companyHasSinglePermission(P.OpportunitiesAddEdit);
export const AllowOpportunitiesDelete = () =>
  userHasSinglePermission(P.OpportunitiesDelete) &&
  companyHasSinglePermission(P.OpportunitiesDelete);
export const AllowOpportunitiesReportsAccess = () =>
  userHasSinglePermission(P.OpportunitiesReports);
